import { createContext, useContext, useState } from "react";

const MinimumPercentContext = createContext();

export function MinimumPercentProvider({ children }) {
  const [minimumPercent, setMinimumPercent] = useState(10); // default 10%

  return (
    <MinimumPercentContext.Provider value={{ minimumPercent, setMinimumPercent }}>
      {children}
    </MinimumPercentContext.Provider>
  );
}

export function useMinimumPercent() {
  return useContext(MinimumPercentContext);
}
